<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '45vw' }"
  [breakpoints]="{ '960px': '65vw', '640px': '90vw' }" [draggable]="false" (onHide)="closeDialog()" [resizable]="false">

  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-3 w-full">
      <div class="position-relative d-inline-block">
        <p-avatar
          [image]="getProfileImage()"
          [label]="getProfileImage() ? undefined : getInitials()"
          size="xlarge"
          [style]="{
            'background-color': getProfileImage() ? 'transparent' : getAvatarColor(),
            color: '#ffffff',
            'font-size': '1.5rem'
          }"
          styleClass="user-avatar">
        </p-avatar>
      </div>
      <div class="flex-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h3 class="m-0 text-white font-bold">{{ fullName() === 'N/A' && user()?.email ? user()!.email : fullName() }}</h3>
          @if (user()?.isPartner) {
            <p-tag icon="pi pi-star" value="Partner" styleClass="p-tag-warning" styleClass="partner-badge" />
          }
        </div>
        <div class="flex align-items-center gap-2">
          <small class="text-white opacity-90">
            <i class="pi pi-envelope mr-1"></i>
            {{ user()?.email }}
          </small>
          @if (user()?.emailVerified) {
            <i class="pi pi-verified text-green-300" title="Email Verified"></i>
          }
        </div>
      </div>
    </div>
  </ng-template>

  @if (user(); as userData) {
    <app-moderation-action-form
      [accountStatus]="$any(userData.accountStatus || 'active')"
      [userActive]="userData.isActive"
      [userName]="userData.firstName ? (userData.firstName + ' ' + userData.lastName + ' (' + userData.email + ')') : userData.email"
      [isReport]="false"
      (onAction)="handleAction($event)"
      (onCancel)="closeDialog()">
    </app-moderation-action-form>
  }
</p-dialog>
